import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47065cf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "app-pac-nav" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "wrap-appointment-patient" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_appointment_form = _resolveComponent("appointment-form")!
  const _component_patient_form = _resolveComponent("patient-form")!
  const _component_patient_history = _resolveComponent("patient-history")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "modal_mask",
        onMousedown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal($event))),
        class: "modal-mask"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("a", {
            ref: "close_modal",
            class: "close-modal",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetCloseNewAppointment()))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'times'] })
          ], 512),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveTab(_ctx.RECORD_TAB.appointment))),
              class: _normalizeClass({
              active: _ctx.active_tab == _ctx.RECORD_TAB.appointment,
            })
            }, " Consulta ", 2),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActiveTab(_ctx.RECORD_TAB.patient))),
              class: _normalizeClass({
              active: _ctx.active_tab == _ctx.RECORD_TAB.patient,
            })
            }, " Paciente ", 2),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setActiveTab(_ctx.RECORD_TAB.history))),
              class: _normalizeClass({
              active: _ctx.active_tab == _ctx.RECORD_TAB.history,
            }),
              disabled: !_ctx.patient_id
            }, " Histórico ", 10, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.active_tab === _ctx.RECORD_TAB.appointment)
              ? (_openBlock(), _createBlock(_component_appointment_form, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.active_tab === _ctx.RECORD_TAB.patient)
              ? (_openBlock(), _createBlock(_component_patient_form, { key: 1 }))
              : _createCommentVNode("", true),
            (_ctx.active_tab === _ctx.RECORD_TAB.history)
              ? (_openBlock(), _createBlock(_component_patient_history, { key: 2 }))
              : _createCommentVNode("", true)
          ])
        ])
      ], 544)
    ]),
    _: 1
  }))
}